import { EnvironmentProviders, importProvidersFrom, InjectionToken, Provider } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationProvider } from '../interfaces';
import { TranslationService } from '../services';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppLanguage } from '../enums';

export const TRANSLATION_TOKEN: InjectionToken<TranslationProvider> = new InjectionToken<TranslationProvider>(
  'TRANSLATION_TOKEN'
);

export const provideTranslation = (): Provider => ({
  provide: TRANSLATION_TOKEN,
  useClass: TranslationService
});

export const provideTranslationDeps = (): (Provider | EnvironmentProviders)[] => {
  return [
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: AppLanguage.pl
      })
    ),
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    })
  ];
};
